import { render, staticRenderFns } from "./TaskRowLanguageCell.vue?vue&type=template&id=4fd5f967&scoped=true&lang=pug&"
import script from "./TaskRowLanguageCell.vue?vue&type=script&lang=js&"
export * from "./TaskRowLanguageCell.vue?vue&type=script&lang=js&"
import style0 from "./TaskRowLanguageCell.vue?vue&type=style&index=0&id=4fd5f967&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd5f967",
  null
  
)

export default component.exports